/*
 * Copyright (c) 2026 CalAmp Corp.  All Rights Reserved
 */
import React from 'react';
import {IconProps} from '../../types/types';
import useIconDLS from '../useIconDLS';

/*
 * Defines the Design Language System (DLS) Notification Calendar Icon component.
 */
export const NotificationCalendarIcon = (props: IconProps) => {
  const {iconSize, iconColor} = useIconDLS(props);
  return (
    <svg width={iconSize} height={iconSize} viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path d='M19.4999 5.77441H4.5C4.22386 5.77441 4 5.99827 4 6.27441V19.6744C4 19.9506 4.22386 20.1744 4.5 20.1744H19.4999C19.776 20.1744 19.9999 19.9506 19.9999 19.6744V6.27441C19.9999 5.99827 19.776 5.77441 19.4999 5.77441Z' stroke={iconColor} strokeWidth='1.5' strokeMiterlimit='10' />
      <path d='M4.10352 10.9736H20.0001' stroke={iconColor} strokeWidth='1.5' strokeMiterlimit='10' />
      <path d='M7.72949 4V7.51255' stroke={iconColor} strokeWidth='1.5' strokeMiterlimit='10' strokeLinecap='round' />
      <path d='M16.0112 4V7.51255' stroke={iconColor} strokeWidth='1.5' strokeMiterlimit='10' strokeLinecap='round' />
    </svg>
  );
};

export default NotificationCalendarIcon;
